import Environment from './Environment';
import SessionService from './SessionService';

class UiService {
    /**
     * UiService constructor
     * @param {SessionService} sessionService
     * @param {Environment} environment
     */
    constructor(sessionService, environment) {
        this.sessionService = sessionService;
        this.environment = environment;

        this.currentScreenSelector = null;
    }

    init() {
        if (this.environment.isMobile) {
            document.getElementsByClassName('wrapper')[0].classList.add('mobile-device');
        }

        if (this.environment.isSafari) {
            document.getElementsByClassName('wrapper')[0].classList.add('safari-browser');
        }

        if (this.environment.isMobileSize) {
            document.getElementById('webcam-buttons').classList.add('mobile-size');
        }

        if (this.environment.isTabletSize) {
            document.getElementById('webcam-buttons').classList.add('tablet-size');
        }

        if (this.environment.isEdge) {
            const videoPlayerWrapper = document.querySelector('.video-player-wrapper');
            if (videoPlayerWrapper) {
                videoPlayerWrapper.classList.add('edge');
            }
        }
    }

    switchScreen(screenSelector) {
        this.sessionService.logMessage('info', 'switchScreen: ' + screenSelector.slice(1));

        if (this.currentScreenSelector != null) {
            document.querySelector(this.currentScreenSelector).classList.remove('active');
        }

        document.querySelector(screenSelector).classList.add('active');

        this.currentScreenSelector = screenSelector;
    }
}

function disable(element) {
    if (element) {
        element.classList.add("disabled-button");
    }
}

function enable(element) {
    if (element) {
        element.classList.remove("disabled-button");
        element.style.display = '';
    }
}

function hide(element) {
    if (element) {
        element.style.display = 'none';
    }
}

function show(element, isBlock = false) {
    if (element) {
        element.style.display = isBlock ? 'block' : '';
    }
}

export { UiService, hide, show, disable, enable };
